module.exports = __webpack_public_path__ + "static/img/activity2.f7b49e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity2.png
// module id = Vckj
// module chunks = 1